
<div class="ticker">
  <transition-group tag="ul" name="ticker">
    <li v-for="crossing in crossings" :key="crossing.id" @click="clickCrossing(crossing)">
      <span class="bib-stripe" :style="styleForCrossing(crossing)">&nbsp;</span>
      {{ displayForCrossing(crossing) }}
    </li>
  </transition-group>
</div>
